import { createContext, useContext } from 'react'
import type { DeployEnv } from './env'

export type KitchensinkVariant = 'spa' | 'mpa'

type KitchensinkContextValue = {
  variant: KitchensinkVariant
  env: DeployEnv
  tenantSubdomain: string
  tenantId: string
  isInitialized: boolean
}

const KitchensinkContext = createContext<KitchensinkContextValue | null>(null)

export const KitchensinkProvider = KitchensinkContext.Provider

export const useKitchensink = (): KitchensinkContextValue => {
  const value = useContext(KitchensinkContext)
  if (!value) throw new Error('useKitchensink must be used inside KitchensinkShell')
  return value
}
